import React, { useEffect } from 'react';
import withView from '../../../cmn/docAutomation/withView';
import { UiView, UiViewContent } from '../../../../library/layout/Index';

const DocGridXYAxisRow = (props)=>{
    const {formObject, viewData, viewRow, rowKey, rowID, reloadSearch} = props

    // console.log("xygrid row 3", viewData);

    const renderXYAxisView = () => {
        let DynamicComponent = formObject.viewMap[viewRow.viewKey];

        if(!DynamicComponent)
        {
            DynamicComponent = formObject.viewMap["vCMNGridLabel"];
        }

        if(!DynamicComponent)
        {
            return null;
        }
        else
        {
            return <DynamicComponent formObject={formObject} viewData={viewData} viewRow={viewRow} rowKey={rowKey} 
            rowID={rowID} reloadSearch={reloadSearch}/>
        }
    }

    // console.log("viewData.rowValues", viewData.rowValues);

    return(
        <div>{renderXYAxisView()}</div>
    )
}

const DocGridXAxisRow = (props)=>{
    const {formObject, viewRow, reloadSearch} = props
    // const {formObject, viewData, viewRow, rowKey, rowID, reloadSearch} = props

    //console.log("xygrid row 2", viewData);

    //each data in a column
    return(
        <div className="uiGridXYCellContainer uiXYGridYRowHeight " style={{backgroundcolor: '#FF0000'}}>
            {
                Object.values(viewRow.childRows).map((row, index)=>(
                    <div key={index} >
                        <DocGridXYAxisRow formObject={formObject} viewData={viewRow.childRows} viewRow={row} rowKey={row.rowKey} rowID={row.dataList.dbRowId} reloadSearch={reloadSearch}></DocGridXYAxisRow>
                    </div>
                ))
            }
        </div>
    )
}

const DocGridYAxisRow = (props)=>{
    const {formObject, viewRow, reloadSearch} = props
    // const {formObject, viewData, viewRow, rowKey, rowID, reloadSearch} = props

    // console.log("xygrid row 2", viewData);

    //each column of a row
    return(
        <div className="uiXYGridYRowHeight">
            <ul className='uiXGridHeaderList uiCornerAll'>
                {
                    Object.values(viewRow.rowValues).map((row, index)=>(
                        <li key={index} className='uiColumn uiXYGridXRowWidth' >
                            <DocGridXAxisRow formObject={formObject} viewData={viewRow.rowValues} viewRow={row} rowKey={row.rowKey} rowID={row.dataList.dbRowId} reloadSearch={reloadSearch}></DocGridXAxisRow>
                        </li>
                    ))
                }
            </ul>
        </div>
    )
}

const DocGridXYAxisData = (props)=>{
    const {formObject, viewData, reloadSearch, xGridSize, contentScroll, onContentScroll} = props

    // console.log("xygrid row 1", viewData);

    const initialiseActions = () => {
        // console.log("custom action set", formObject.dataList);
        if(formObject.dataList) {
            formObject.initialiseCustomActions(formObject.dataList.actionName, 
                formObject.dataList.depActions);
        }
    }

    useEffect(initialiseActions, [props.viewData]);
    
    //each row
    if(viewData){
        return(
            <UiView>
                <UiViewContent>
                    <ul className="uiListContainer uiListTable content-scroll" style={{height:`${(xGridSize && xGridSize.height)}px`,overflowY: "scroll" }} 
                        id="content-scroll"
                        ref={contentScroll}
                        onScroll={onContentScroll}>
                        {
                            Object.values(viewData).map((row, index)=>(
                                <li key={index} className='uiXYRow uiListRow'>
                                    <DocGridYAxisRow formObject={formObject} viewData={viewData} viewRow={row} rowKey={row.rowKey} rowID={row.dataList.dbRowId} reloadSearch={reloadSearch}></DocGridYAxisRow>
                                </li>
                            ))
                        }
                    </ul>
                </UiViewContent>
            </UiView>
        )
    }
    else return null;
}

export default withView(DocGridXYAxisData, '', '', 0);
